import { render, staticRenderFns } from "./admin_create_news.vue?vue&type=template&id=821a457a&scoped=true"
import script from "./admin_create_news.vue?vue&type=script&lang=js"
export * from "./admin_create_news.vue?vue&type=script&lang=js"
import style0 from "./admin_create_news.vue?vue&type=style&index=0&id=821a457a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821a457a",
  null
  
)

export default component.exports